import { useMemo } from 'react'

import { DatePicker } from 'antd'
import moment from 'moment'
import { faPlus, faTrash } from '@fortawesome/pro-solid-svg-icons'

import { EUROPEAN_DATE } from '../../../utils/constants'
import { DAY } from '../../../utils/momentjs'
import IconButton from '../Buttons/IconButton'

const { RangePicker } = DatePicker

const MultiPeriodsPicker = ({ className, minDate = null, periods = [], onChange }) => {
  const localClassName = useMemo(() => (className ?? '') + ' flex-col bdr-1 bdr-rds-4 pd-16', [className])

  const localPeriods = useMemo(() => periods.map(p => [p.startDate, p.endDate]), [periods])
  const seed = useMemo(() => minDate === null ? moment() : moment(minDate), [minDate])

  return (
    <div className={localClassName}>
      {localPeriods.map((dates, index) => (
        <div key={'picker_' + index} className='flex-row mb-4 ai-ctr jc-between'>
          <RangePicker
            format={EUROPEAN_DATE}
            className='w-100'
            value={dates}
            disabledDate={minDate === null ? undefined : date => date.isBefore(minDate, DAY)}
            onChange={dates => onChange(periods.map((p, i) => i === index ? { ...p, startDate: dates?.[0] ?? null, endDate: dates?.[1] ?? null } : p))}
          />
          <IconButton className='ml-4' icon={faTrash} size='small' type='danger' onClick={() => onChange(periods.filter((d, i) => i !== index))} />
        </div>
      ))}
      <IconButton className='mt-4' icon={faPlus} onClick={() => onChange([...periods, { startDate: seed.clone(), endDate: seed.clone() }])} />
    </div>
  )
}

export default MultiPeriodsPicker
